export default "__VITE_ASSET__DziK$213__"